export default "__VITE_ASSET__W0lXf7aS__"